var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('Spinner',{staticClass:"mx-auto"}):_c('button',{staticClass:"inline-block w-full px-5 py-3 font-bold tracking-wide text-center rounded",class:_vm.variant,attrs:{"disabled":_vm.isLoading},on:{"click":_vm.handleClick}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }